let Nodes = {
    sel: {},
    el: {}
};

export default Nodes;

$(() => {
    Nodes.sel.wrapContent = '#wrap-content';
    Nodes.el.wrapContent = $('#wrap-content');

    Nodes.sel.wrapOffscreen = '#wrap-offscreen';
    Nodes.el.wrapOffscreen = $('#wrap-offscreen');

    Nodes.sel.wrapContentBlurred= '.blurred';
    Nodes.el.wrapContentBlurred= $('.blurred');

    Nodes.sel.designerDesk = '#designer-desk';
    Nodes.el.designerDesk = $('#designer-desk');
});